module.exports = __webpack_public_path__ + "img/singup9.ccbb5118.jpg";